export {
  ProductRecommendationsRenderer,
  validateSkus,
} from './ProductRecommendationsRenderer'
